/* eslint max-len: 0 */
import React, { Component } from 'react';

export default class PreviewPageThumbnail extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="190"
        height="131"
        viewBox="0 0 190 131"
      >
        <g fill="none" fillRule="evenodd" strokeWidth="3">
          <path fill="#FFF" stroke="#E0E0E0" d="M1.5 1.5h187v128H1.5z" />
          <path fill="#F5C8C0" stroke="#E84601" d="M1.5 1.5h187v86H1.5z" />
          <path
            fill="#FFF"
            stroke="#CDCECF"
            d="M116.5 98.5h49.743v19.03H116.5zM24.5 98.5h82.743v10H24.5zM24.5 117.5h82.743v1H24.5z"
          />
        </g>
      </svg>
    );
  }
}
